define('SageDotCom/DataLayer/Events/DynamicProductModal',["jquery", "SageDotCom/DataLayer/Events/eventBase"],
    function ($, EventBase) {
        function DynamicProductModalEvent(eventName, eventLabel, elementText) {
            EventBase.call(this);
            this.props = {
                'event': eventName,
                'pop_up_type': "cross-sell",
                'subject': eventLabel
            };

            if (elementText && elementText !== null && elementText !== "") {
                this.props.element_text = elementText;
            }
        }

        DynamicProductModalEvent.prototype = Object.create(EventBase.prototype);
        return DynamicProductModalEvent;
    });

